import { ReactNode } from 'react';
import { BoxWrapper } from './styles';
import { BoxWrapperPropsType } from './boxHelpers';

type BoxType = BoxWrapperPropsType & {
  children: ReactNode;
  as?: keyof HTMLElementTagNameMap;
};

export const Box = (props: BoxType) => {
  const { children, ...restProps } = props;

  return <BoxWrapper {...restProps}>{children}</BoxWrapper>;
};
